import { jsx } from "react/jsx-runtime";
import { useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { OverlayFrame, OverlayContent } from "./overlay.styles.es.js";
const propTypes = {
  animation: PropTypes.bool,
  "aria-label": PropTypes.string,
  "aria-labelledby": PropTypes.string,
  children: PropTypes.node,
  closeOnOverlayClick: PropTypes.bool,
  height: PropTypes.number,
  initialFocusRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  minHeight: PropTypes.number,
  minWidth: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  width: PropTypes.number
};
const defaultProps = {
  animation: true,
  "aria-label": void 0,
  "aria-labelledby": void 0,
  children: void 0,
  closeOnOverlayClick: false,
  height: void 0,
  initialFocusRef: void 0,
  minHeight: 0,
  minWidth: void 0,
  width: void 0
};
const Overlay = ({
  animation,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledby,
  children,
  closeOnOverlayClick,
  height,
  initialFocusRef,
  minHeight,
  minWidth,
  onClose,
  width,
  ...restProps
}) => {
  const overlayRef = useRef();
  const handleOverlayClick = useCallback(
    (event) => {
      if (overlayRef && event.target === overlayRef.current) {
        onClose();
      }
    },
    [onClose]
  );
  const handleKeyDown = useCallback(
    (event) => {
      event.stopPropagation();
      if (event.key === "Escape") {
        onClose();
      }
    },
    [onClose]
  );
  return /* @__PURE__ */ jsx(
    OverlayFrame,
    {
      $animation: animation,
      ref: overlayRef,
      "data-testid": "overlay",
      initialFocusRef,
      onClick: closeOnOverlayClick ? handleOverlayClick : void 0,
      onKeyDown: handleKeyDown,
      role: "presentation",
      tabIndex: "0",
      children: /* @__PURE__ */ jsx(
        OverlayContent,
        {
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledby,
          $animation: animation,
          $height: height,
          $minHeight: minHeight,
          $minWidth: minWidth,
          $width: width,
          ...restProps,
          children
        }
      )
    }
  );
};
Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
export {
  Overlay
};
